import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/**
 * When scrollWheelZoom is on, plain wheel zoom is handled by Leaflet.
 * Ctrl+wheel still triggers browser page zoom on many platforms — intercept it on the map.
 */
export default function MapWheelZoomHandler() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();

    const onWheel = (event: WheelEvent) => {
      if (!event.ctrlKey) return;

      event.preventDefault();
      event.stopPropagation();

      if (event.deltaY > 0) {
        map.zoomOut();
      } else if (event.deltaY < 0) {
        map.zoomIn();
      }
    };

    container.addEventListener('wheel', onWheel, { passive: false });
    return () => container.removeEventListener('wheel', onWheel);
  }, [map]);

  return null;
}
